import React from 'react'
import { Link } from 'react-router-dom'

const WomenOfChaashniWP = () => {
  return (
<div className='womenofchaashni'>
  <div className='flare-black'><img src='images/about/flare-black.png' alt='' /></div>
<div className="category-full">
  <div className="container">
    <ul>     
      <li>
        <div className="img-box"><Link to={`https://wa.me/${process.env.REACT_APP_WHATSAPP_NO}`} target="_blank" rel="noopener noreferrer">
        <picture>  
          <source media="(min-width:1199px)"  srcset={`${process.env.REACT_APP_IMAGE_URL}womenofchaashni/ready-to-ship.jpg`} />
          <img src={`${process.env.REACT_APP_IMAGE_URL}womenofchaashni/ready-to-ship-mobile.jpg`} alt="Ready To Ship Styles" width="100%" height="auto" />
        </picture> 
        </Link></div>
      </li>
      <li>
        <div className="img-box">
        <picture>
          <source media="(min-width:1199px)"  srcset={`${process.env.REACT_APP_IMAGE_URL}womenofchaashni/fri-yay-sale.jpg`} />
          <img src={`${process.env.REACT_APP_IMAGE_URL}womenofchaashni/fab-friday-mobile.jpg`} alt="Fri Yay Sale"  width="100%" height="auto" />
        </picture></div>
      </li>
    </ul>
  </div>
</div>
</div>

  )
}

export default WomenOfChaashniWP
